import { useState, useEffect } from "react";
import { ISelectDocumentTypeProps } from "./AddDocumentInterfaces";
import { Row, Col } from "react-bootstrap";
import { document_descriptions, document_types } from "../../common/Contants";
import { ComponentStruct } from "../../common/Interfaces";
import SearchDropDown from "../generic_components/SearchDropDown";

export default function SelectDocumentType({
  clear,
  typeDefaultValue,
  descriptionDefaultValue,
  onChange,
}: ISelectDocumentTypeProps) {
  const [selectedType, setSelectedType] = useState<ComponentStruct>(
    typeDefaultValue || { key: "0", label: "deselect" }
  );
  const [descValue, setDescValue] = useState(descriptionDefaultValue?.label);
  const [selectedDescription, setSelectedDescription] =
    useState<ComponentStruct | null>(
      descriptionDefaultValue || { key: "0", label: "deselect" }
    );
  const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
  const [isDescriptionDropdownOpen, setIsDescriptionDropdownOpen] =
    useState(false);

  const getDescriptions = (type: ComponentStruct): ComponentStruct[] => {
    return document_descriptions
      .filter((description) => description.type === type.key)
      .map((description) => ({
        key: description.key,
        label: description.label,
      }));
  };

  const [descriptions, setDescriptions] = useState<ComponentStruct[]>([]);

  useEffect(() => {
    const newDescriptions = getDescriptions(selectedType);
    setDescriptions(newDescriptions);
    if (newDescriptions.length === 0) {
      setSelectedDescription({ key: "0", label: "deselect" });
      onChange(selectedType, null);
    } else {
      setSelectedDescription({ key: "0", label: "deselect" });
      onChange(selectedType, { key: "0", label: "deselect" });
    }
  }, [selectedType]);

  useEffect(() => {
    setSelectedDescription(
      descriptionDefaultValue || { key: "0", label: "deselect" }
    );
    setDescValue(descriptionDefaultValue?.label);
    setSelectedType(typeDefaultValue || { key: "0", label: "deselect" });
    onChange(
      typeDefaultValue || { key: "0", label: "deselect" },
      descriptionDefaultValue || null
    );
  }, [clear]);

  return (
    <>
      <Row className="padding-top">
        <Col xs={2}>
          <label>Document Type</label>
        </Col>
        <Col xs={4}>
          <SearchDropDown
            clear={clear}
            options={document_types}
            setOpen={setIsTypeDropdownOpen}
            close={isDescriptionDropdownOpen}
            onSelect={(selectedKey, selectedLabel) => {
              const sel = { key: selectedKey, label: selectedLabel };
              setSelectedType(sel);
              setSelectedDescription(null);
              setDescValue("Select");
              onChange(sel, null);
            }}
            defaultValue={typeDefaultValue?.label}
          />
        </Col>
      </Row>
      <Row className="padding-top">
        <Col xs={2}>
          <label>Document Description</label>
        </Col>
        <Col xs={4}>
          <SearchDropDown
            clear={clear}
            options={descriptions}
            setOpen={setIsDescriptionDropdownOpen}
            close={isTypeDropdownOpen}
            onSelect={(selectedKey, selectedLabel) => {
              const sel = { key: selectedKey, label: selectedLabel };
              setSelectedDescription(sel);
              onChange(selectedType, sel);
            }}
            disabled={descriptions.length === 0}
            defaultValue={descValue}
          />
        </Col>
      </Row>
    </>
  );
}
